/**
 * Created by Mark on 23/11/2016.
 */

import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_WORDS_LEARNT_ACCOUNT_LEVEL: ENVIRONMENT_CONSTANTS.BASE_URL + '/scoresController/getTotalsForAccount',
    GET_CLASS_SCORES : ENVIRONMENT_CONSTANTS.BASE_URL + '/scoresController/getClassModuleScores',
    GET_CLASS_LANGUAGES :ENVIRONMENT_CONSTANTS.BASE_URL + '/scoresController/getLanguagesWithScore',
    GET_STUDENT_SCORES  :ENVIRONMENT_CONSTANTS.BASE_URL + '/scoresController/getStudentScores',
    GET_STUDENT_TOTAL_SKILLS  :ENVIRONMENT_CONSTANTS.BASE_URL + '/scoresController/getTotalsForStudent',
    GET_CLASS_TOTAL_SKILLS  :ENVIRONMENT_CONSTANTS.BASE_URL + '/scoresController/getTotalsForClass',
    UPDATE_CLASS_SCORES : 'UPDATE_CLASS_SCORES',
    UPDATE_AVERAGE_ACCOUNT_LEVEL: 'UPDATE_AVERAGE_ACCOUNT_LEVEL',
    UPDATE_TOTAL_CLASS_LEVEL: 'UPDATE_TOTAL_CLASS_LEVEL',
    UPDATE_TOTAL_STUDENT_LEVEL: 'UPDATE_TOTAL_STUDENT_LEVEL'
}


// WEBPACK FOOTER //
// ./src/constants/scores.js